import classNames from 'classnames';
import PropTypes from "prop-types";

import 'shared/components/ToggleGroup/styles.scss';


function ToggleGroup({items, value, onChange, ...props}) {
    return <div className={"ToggleGroup"} {...props}>
        {items.map(({value: itemValue, icon, iconSelected, text}) => (
            <button
                key={itemValue}
                className={
                    classNames(
                        'ToggleGroup__Item',
                        {'Selected': itemValue === value},
                    )
                }
                onClick={() => onChange(itemValue)}
            >
                {icon && <img alt={`${text} icon`} src={icon}/>}
                {
                    (iconSelected || icon)
                    && <img className={"Selected"} alt={`${text} icon selected`} src={iconSelected || icon}/>
                }
                <span>{text}</span>
            </button>
        ))}
    </div>;
}

ToggleGroup.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            icon: PropTypes.node,
            iconSelected: PropTypes.node,
            text: PropTypes.text.isRequired,
        }),
    ).isRequired,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default ToggleGroup;
